import { getPrimaryTracker, setPrimaryTracker } from 'usage-tracker-container';
const getStandaloneTracker = () => getPrimaryTracker();
class UsageTracker {
  trackStandalone(eventName, eventProps) {
    try {
      getStandaloneTracker().track('Learning Center', eventName, eventProps);
    } catch (e) {
      // getPrimaryTracker throws synchronously when the named tracker is not
      // registered (SSR, Storybook, future consumer that hasn't wired the
      // container). Log and swallow so a missing wire-up doesn't crash the UI.
      console.error(`academy-common-lib UsageTracker: tracker not registered. Call setPrimaryTracker(tracker) at app boot or set tracker: { provideLegacyDefaultPrimaryTracker: true } in quartz config.`, e);
    }
  }
}
export const registerPrimaryTracker = tracker => {
  setPrimaryTracker(tracker);
};
export default new UsageTracker();